'use strict';

import { Component, Input, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

@Component({
  selector: 'menu-toggle',
  templateUrl: './menu-toggle.component.html',
  styleUrls: ['./menu-toggle.component.scss']
})
export class MenuToggleComponent implements OnInit {
  @Input() section: any;
  @Input() isOpen = false;
  @Input() renderContent = false;
  @Input() expanded = true;
  routes: any = [];

  constructor(private router: Router) { }

  ngOnInit(): any {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.isOpen = this.shouldExpand(event.url);
        }
      });
  }

  expandWith(state, sectionRoutes, currentRoute = this.router.url) {
    this.isOpen = state;
    this.routes = sectionRoutes;
    this.shouldExpand(currentRoute);
  }

  shouldExpand(currentRoute): boolean {
    let hasActiveRoute = false;

    if (this.routes && this.routes.length) {
      this.routes.map(function(route) {
        if (route.url === currentRoute) {
          hasActiveRoute = true;
        }
      });
      if (this.section.url === currentRoute) {
        hasActiveRoute = true;
      }
    } else {
      if (this.section.url === currentRoute) {
        hasActiveRoute = true;
      }
    }

    this.isOpen = hasActiveRoute;
    return hasActiveRoute;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/menu-toggle/menu-toggle.component.ts